/**
 * Wedding CSV exports — the one place a download is started.
 *
 * The endpoints (`/books/export.csv`, `/books/:bookId/guests/export.csv`,
 * `/members/export.csv`) stream a file rather than answering the `{ success,
 * data }` envelope every other wedding call speaks, so they do not belong in
 * `weddingApi.ts`. Auth is the `admin_access_token` cookie, which a plain
 * navigation carries — the same mechanism `store-analytics/
 * StoreClickAnalyticsPage.tsx` has used since it shipped.
 *
 * WHY A NAMED FUNCTION RATHER THAN AN INLINE `window.location.href = …`.
 * jsdom refuses a real navigation, so an inline assignment is untestable
 * without monkey-patching `window.location`. A module export can simply be
 * mocked, which is what lets the page tests assert the exact URL — and the URL
 * is the only part worth asserting, because THE EXPORT MUST CARRY WHAT THE GRID
 * IS SHOWING. A CSV that disagrees with the screen it came from is worse than
 * no CSV: it is the same filename holding a different dataset.
 */

const BASE = '/api/admin/wedding';

export type CsvParams = Record<string, string | number | boolean | undefined | null>;

/**
 * Builds an absolute export URL, skipping undefined/null/empty values so an
 * unfiltered export is a bare path rather than a trail of empty keys.
 */
export function csvUrl(path: string, params: CsvParams = {}): string {
  const parts: string[] = [];
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue;
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  }
  return `${BASE}${path}${parts.length ? `?${parts.join('&')}` : ''}`;
}

/** Hands the URL to the browser; the cookie rides along and the file downloads. */
export function startCsvDownload(url: string): void {
  window.location.href = url;
}

export default startCsvDownload;
